/* Marigold & Mesh — theme scripts */
(function () {
  'use strict';

  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  /* ------------------------------------------------------------------ */
  /* Toast                                                               */
  /* ------------------------------------------------------------------ */
  let toastTimer;
  function toast(message) {
    const el = $('#ThemeToast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  /* ------------------------------------------------------------------ */
  /* Drawers                                                             */
  /* ------------------------------------------------------------------ */
  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    const focusable = drawer.querySelector('.drawer__close');
    if (focusable) setTimeout(() => focusable.focus(), 60);
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.drawer.is-open')) {
      document.body.classList.remove('no-scroll');
    }
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.drawer'));
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const open = document.querySelector('.drawer.is-open');
      if (open) closeDrawer(open);
      const facets = document.querySelector('.facets.is-open');
      if (facets) {
        facets.classList.remove('is-open');
        document.body.classList.remove('no-scroll');
      }
    }
  });

  /* ------------------------------------------------------------------ */
  /* Mobile nav accordions                                               */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-mobile-submenu]');
    if (!toggle) return;
    e.preventDefault();
    const sub = toggle.nextElementSibling;
    if (!sub) return;
    const open = sub.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ------------------------------------------------------------------ */
  /* Mobile facet panel                                                  */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-facets-open]')) {
      const panel = $('#FacetsPanel');
      if (panel) {
        panel.classList.add('is-open');
        document.body.classList.add('no-scroll');
      }
    }
    if (e.target.closest('[data-facets-close]')) {
      const panel = $('#FacetsPanel');
      if (panel) {
        panel.classList.remove('is-open');
        document.body.classList.remove('no-scroll');
      }
    }
  });

  /* ------------------------------------------------------------------ */
  /* Facet + sort auto-submit                                            */
  /* ------------------------------------------------------------------ */
  $$('[data-auto-submit]').forEach((form) => {
    form.addEventListener('change', () => {
      form.submit();
    });
  });

  /* ------------------------------------------------------------------ */
  /* Cart helpers                                                        */
  /* ------------------------------------------------------------------ */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  async function refreshCartSections() {
    const ids = [];
    if ($('#CartDrawer')) ids.push('cart-drawer');
    if (!ids.length) return;
    try {
      const res = await fetch(`${window.routes.cart_url}?sections=${ids.join(',')}`);
      const data = await res.json();
      if (data['cart-drawer']) {
        const parsed = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        const fresh = parsed.querySelector('#CartDrawer');
        const current = $('#CartDrawer');
        if (fresh && current) {
          const wasOpen = current.classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          if (wasOpen) current.classList.add('is-open');
        }
      }
    } catch (err) {
      /* silent */
    }
  }

  async function addToCart(payload, button) {
    if (button) button.classList.add('is-loading');
    try {
      const res = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      if (data.status) {
        toast(data.description || data.message || 'Could not add to cart');
        return;
      }
      const cartRes = await fetch(`${window.routes.cart_url}.js`);
      const cart = await cartRes.json();
      updateCartCount(cart.item_count);
      await refreshCartSections();
      if (window.cartDrawerEnabled) {
        openDrawer('CartDrawer');
      } else {
        toast(window.themeStrings.added);
      }
    } catch (err) {
      toast('Something went wrong. Please try again.');
    } finally {
      if (button) button.classList.remove('is-loading');
    }
  }

  /* Quick add buttons on product cards */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const id = btn.getAttribute('data-variant-id');
    if (!id) return;
    addToCart({ items: [{ id: Number(id), quantity: 1 }] }, btn);
  });

  /* Product form */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const formData = new FormData(form);
    const payload = {
      items: [
        {
          id: Number(formData.get('id')),
          quantity: Number(formData.get('quantity') || 1)
        }
      ]
    };
    addToCart(payload, form.querySelector('[data-add-button]'));
  });

  /* Cart line changes */
  async function changeLine(line, quantity, scope) {
    if (scope) scope.classList.add('is-loading');
    try {
      const res = await fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
      });
      const cart = await res.json();
      updateCartCount(cart.item_count);
      if (document.body.classList.contains('template--cart')) {
        window.location.reload();
        return;
      }
      await refreshCartSections();
    } catch (err) {
      toast('Could not update your cart.');
    } finally {
      if (scope) scope.classList.remove('is-loading');
    }
  }

  document.addEventListener('click', (e) => {
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-line'), 0, remove.closest('.cart-item'));
      return;
    }

    const qtyBtn = e.target.closest('[data-qty-change]');
    if (!qtyBtn) return;
    e.preventDefault();
    const wrap = qtyBtn.closest('.qty');
    const input = wrap ? wrap.querySelector('input') : null;
    if (!input) return;
    const step = qtyBtn.getAttribute('data-qty-change') === 'up' ? 1 : -1;
    const min = Number(input.getAttribute('min') || 0);
    const next = Math.max(min, Number(input.value || 1) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-line'), input.value, input.closest('.cart-item'));
  });

  /* ------------------------------------------------------------------ */
  /* Product: variant picker + gallery                                   */
  /* ------------------------------------------------------------------ */
  $$('[data-product-root]').forEach((root) => {
    const dataEl = $('[data-variant-json]', root);
    if (!dataEl) return;

    let variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }

    const form = $('[data-product-form]', root);
    const idInput = form ? form.querySelector('[name="id"]') : null;
    const addButton = $('[data-add-button]', root);
    const priceEl = $('[data-price-wrap]', root);
    const skuEl = $('[data-sku]', root);

    function currentOptions() {
      return $$('[data-option-index]', root)
        .filter((el) => el.checked)
        .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex))
        .map((el) => el.value);
    }

    function findVariant(selected) {
      return variants.find((v) =>
        v.options.every((opt, i) => opt === selected[i])
      );
    }

    function render(variant) {
      if (!variant) {
        if (addButton) {
          addButton.setAttribute('aria-disabled', 'true');
          addButton.textContent = window.themeStrings.unavailable;
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (addButton) {
        if (variant.available) {
          addButton.removeAttribute('aria-disabled');
          addButton.textContent = addButton.dataset.preorder === 'true'
            ? 'Preorder'
            : window.themeStrings.addToCart;
        } else {
          addButton.setAttribute('aria-disabled', 'true');
          addButton.textContent = window.themeStrings.soldOut;
        }
      }

      if (priceEl && variant.price_html) priceEl.innerHTML = variant.price_html;
      if (skuEl) skuEl.textContent = variant.sku || '';

      if (variant.featured_media_id) {
        const thumb = root.querySelector(`[data-media-id="${variant.featured_media_id}"]`);
        if (thumb) thumb.click();
      }

      if (history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', (e) => {
      if (!e.target.matches('[data-option-index]')) return;
      render(findVariant(currentOptions()));
    });

    /* Gallery */
    const mainImg = $('[data-main-image]', root);
    $$('[data-thumb]', root).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!mainImg) return;
        const src = thumb.getAttribute('data-full');
        const srcset = thumb.getAttribute('data-srcset');
        if (src) mainImg.src = src;
        if (srcset) mainImg.srcset = srcset;
        mainImg.alt = thumb.getAttribute('data-alt') || mainImg.alt;
        $$('[data-thumb]', root).forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  /* ------------------------------------------------------------------ */
  /* Scroll reveal                                                       */
  /* ------------------------------------------------------------------ */
  if (document.body.classList.contains('animate-enabled') && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    $$('.reveal').forEach((el) => observer.observe(el));
  }

  /* ------------------------------------------------------------------ */
  /* Theme editor support                                                */
  /* ------------------------------------------------------------------ */
  document.addEventListener('shopify:section:load', () => {
    $$('.reveal').forEach((el) => el.classList.add('is-visible'));
  });
})();
